import { lazy } from "react";

const routes = [
  {
    path: "/bank",
    element: lazy(() => import("../pages/Bank")),
  },
  {
    path: "/bank/add",
    element: lazy(() => import("../pages/Bank/create")),
  },
  {
    path: "/bank/edit/:id",
    element: lazy(() => import("../pages/Bank/edit")),
  },
];

export default routes;
